<template>
  <BaseTitle :schedule="schedule" :metadata-items="metadataList">
    <template v-if="schedule.separateAccountManagerFee">
      {{ schedule.programName || schedule.name }}
    </template>
  </BaseTitle>
</template>
<script>
import BaseTitle from './BaseTitle';
import MaxFeeMetadataMixin from '../../mixins/metadata/max-fee-mixin';

export default {
  name: 'max-fee-title',
  components: {
    BaseTitle,
  },
  mixins: [MaxFeeMetadataMixin],
  props: {
    schedule: Object,
    isProgramBaseMode: {
      type: Boolean,
      default: false,
    },
    programOptions: Array,
  },
  inject: ['translate', 'formatNumber'],
  computed: {
    metadataList() {
      const metadataList = [
        {
          label: this.feeScheduleDescription,
        },
        {
          label: this.maxDiscountDescription,
        },
      ];
      if (this.isProgramBasedMode) {
        metadataList.push({
          label: this.validSelectedProgramsString,
          truncateClass: this.$style['program-metadata'],
          enableTruncate: true,
        });
      }
      if (this.schedule.separateAccountManagerFee) {
        metadataList.push({
          label: this.translate('smaMetadata'),
        });
      }
      return metadataList;
    },
    feeScheduleDescription() {
      const maxFee = this.formatNumber(this.schedule.maxFee, 'shortDecimal');
      return `${this.translate('maxFee')} ${maxFee} %`;
    },
  },
};
</script>

<style lang="scss" module>
.program-metadata {
  max-width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
